export const USER_ACTIVITY_LOGGING_URL = `/api/user_activity/register`

export const USER_ACTIVITY_API_PARAMS = Object.freeze({
    ROUTE : "route",
    SCREEN : "screen",
    ACTION_TYPE: 'action_type',
    ACTION: 'action',
    ACTION_TARGET: 'action_target'
})

export const CommonScreenConstants = Object.freeze({
    SCREEN1 : "Regional Overview",
    SCREEN2 : "Industry Overview",
    SCREEN3 : "Industry Detail",
    SCREEN4 : "Occupation Overview",
    SCREEN5 : "Occupation Detail",
    SCREEN6 : "Pathways",
    SCREEN7 : "Education"
})

export class UserActivityConstants {
    static ACTION_TYPES = {
        CLICK : "Click",
        HOVER : "Hover",
        SELECT_DROPDOWN: "Select Dropdown",
        SELECT_ITEM : "Select",
        TOGGLE : "Toggle",
        SELECT_RADIO_ITEM : "Select Radio Item",
        LOGIN : "Login",
    }

    static COMMON_ACTIONS = {
        TOGGLE_SCREEN_ORIENTATION : "Toggle Screen Orientation",
        TOGGLE_DATA_SOURCE : "Toggle Data Source",
        EXPAND_SIDEBAR : "Expand Sidebar",
        CHANGE_TAB : "Change tab from sidebar",
        LOGIN : "Login"
    }

    static SCREEN1 = {
        NAME : "Regional Overview",
        ACTIONS: {
            CHANGE_REGION : "Change Region",
            CHANGE_JOB_TYPE : "Change Job Type",
            HOVER_OVER_REGION : "Hover over region",
            SELECT_SUB_MENU : "Change Sub Menu",
            CHANGE_MAP_MENU : "Change Map Menu",
            HOVER : {
                EDUCATION_SCORE : "Hover over Education Score",
                ECONOMY_SCORE : "Hover over Economy Score",
                OVERALL_SCORE : "Hover over Overall Score",
            }
        }
    }

    static SCREEN2 = {
        NAME : "Industry Overview",
        ACTIONS: {
            SELECT_JOB_TYPE : "Select Job Type",
            TOGGLE_PRESENTATION_MODE : "Toggle Presentation Mode",
            FOCUS_INDUSTRY : "Focus Industry"
        }
    }

    static SCREEN3 = {
        NAME : "Industry Detail",
        ACTIONS: {
            SELECT_JOB_TYPE : "Select Job Type",
            TOGGLE_PRESENTATION_MODE : "Toggle Presentation Mode",
            CHANGE_INDUSTRY_TYPE : "Change Industry Type",
            CHANGE_SUB_MENU : "Change Sub Menu",

            HOVER : {
                AGE_GROUP : "Hover over age Group",
                RACE_OR_ETHNICITY : "Hover over race/Ethnicity",
                GENDER : "Hover over gender"
            }
        }
    }

    static SIDEBAR = {
        NAME : "Common Screen"
    }

    static SCREEN4 = {
        NAME : "Occupation Overview",
        ACTIONS: {
            SELECT_INDUSTRY_TYPE : "Select Industry Type",
            SELECT_INDUSTRY_OCCUPATION : "Select Industry Occupation",
            SELECT_CROSS_FACTOR_TYPE : "Select Industry Cross Factor Type",
            TOGGLE_PRESENTATION_MODE : "Toggle Presentation Mode",
            SET_OCCUPATION_FOCUS : "Set Occupation Focus"
        }
    }

    static SCREEN5 = {
        NAME : "Occupation Detail",
        ACTIONS: {
           SELECT_OCCUPATION : "Select Occupation",
           CHANGE_SUB_MENU : "Change Sub Menu",
        }
    }

    static SCREEN6 = {
        NAME : "Education",
        ACTIONS : {
            CHANGE_SUB_MENU : "Change Sub Menu",
            SELECT_CTE_FILTER : "Select CTE Filter",
        }
    }

    static SCREEN7 = {
        NAME : "Pathways",
        ACTIONS: {
            CHANGE_SUB_MENU : "Change Sub Menu",
            
        }
    }

}